import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { SpacesProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const SPACES_QUERY = graphql`
query NodeAllSpacesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Spaces" } }) {
    nodes {
      data
    }
  }
}
`;

export const SpacesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(SPACES_QUERY), 'items')}>{children}</Provider>;
};
